import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import '../whats-new-tour.css';
import { TourStep } from '../configs/changelog';

export const useFeatureTour = () => {
  const navigate = useNavigate();

  const startTour = useCallback(
    (steps: TourStep[], route?: string) => {
      const launch = () => {
        // Small delay to let the page render before highlighting elements
        setTimeout(() => {
          const driverObj = driver({
            showProgress: true,
            animate: true,
            allowClose: true,
            overlayColor: 'rgba(0, 0, 0, 0.6)',
            stagePadding: 8,
            stageRadius: 8,
            popoverClass: 'whats-new-tour-popover',
            steps: steps.map((step) => ({
              element: step.element,
              popover: {
                title: step.title,
                description: step.description,
                side: step.side || 'bottom',
              },
            })),
          });
          driverObj.drive();
        }, 600);
      };

      if (route) {
        navigate(route);
        launch();
      } else {
        launch();
      }
    },
    [navigate]
  );

  return { startTour };
};
